import Ad from '../../../api/Ad';
import * as types from './mutation-types';

export const getAll = async ({ commit, rootState }, payload) => {
    const json = await new Ad().getAll({
        ...payload,
        language: rootState.auth.currentLang,
    });

    commit(types.ADS, json);
};

export const addUserAd = async (content, { id }) => {
    await new Ad().addUserAd(id);
};

export default {
    getAll,
    addUserAd,
};



// WEBPACK FOOTER //
// ./src/store/modules/ad/actions.js